import { render } from "./PrefacePopContainer.vue?vue&type=template&id=ea444b9a&scoped=true"
import script from "./PrefacePopContainer.vue?vue&type=script&lang=js"
export * from "./PrefacePopContainer.vue?vue&type=script&lang=js"

import "./PrefacePopContainer.vue?vue&type=style&index=0&id=ea444b9a&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea444b9a"]])

export default __exports__